import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

// Styles
import "@/assets/slide-menu-animations.css"

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.mount('#mobile-navigation')
